export const queryKeys = {
  REGION_SELECT: "region-select",
  DISTRICT_SELECT: "district-select",
  PROBLEM_SELECT: "problem-select",
  NEIGHBORHOOD_SELECT: "neighborhood-select",
  TAG_SELECT: "tag-select",
}
